module.exports = __webpack_public_path__ + "static/media/heroku.b38ff61a.svg";